import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormGroup,
  Panel,
  PanelGroup,
  Row,
} from 'react-bootstrap'

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { browserHistory, Link } from 'react-router'
import { Typeahead } from 'react-bootstrap-typeahead';

import Collapsible from '../collapsible'
import DatePicker from 'react-bootstrap-date-picker'
import Loadable from 'react-loading-overlay'


@observer(['globals', 'invoices', 'sources'])
export default class PaidInvoicesBySourceReport extends Component {

  constructor(props) {
    super(props)

    this.state = {
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      loadableState: false,
      defaultSourceId: this.props.sourceId,
      defaultSourceName: this.props.sourceName,
      selectedSourceId: 0,
      selectedSourceName: '',
      reports: [],
    }

    this.props.sources.loadAllSources();
  }

  componentDidMount() {
    if (this.props.invoices.paidInvoicesBySource.length > 0 && (this.state.startDate == '' || this.state.endDate == '')) {
      this.props.invoices.resetPaidInvoicesBySource()
    }

    if (this.props.sourceId > 0 && this.props.sourceName != null && this.props.startDate != null && this.props.endDate != null) {
      this.setState({
        selectedSourceId: this.props.sourceId,
        selectedSourceName: this.props.sourceName,
        startDate: this.props.startDate,
        endDate: this.props.endDate,
      }, () => {
        this.runPaidInvoiceBySourceReport();
      })
    }
  }

  // FORM VALIDATION FUNCTIONS
  validateReportForm() {
    if (this.getSourceValidationState() == 'error') {
      return false;
    }

    if (this.getStartDateValidationState() == 'error') {
      return false;
    }

    if (this.getEndDateValidationState() == 'error') {
      return false;
    }

    return true;
  }

  getSourceValidationState() {
    if (this.state && this.state.selectedSourceId != 0) {
      return 'success';
    } else {
      return 'error';
    }
  }

  getStartDateValidationState() {
    if (this.state && this.state.startDate != '') {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEndDateValidationState() {
    if (this.state && this.state.endDate != 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  //STATE CHANGE FUNCTIONS
  onStartDateChanged(value, formattedValue) {
    if (formattedValue == null) {
      formattedValue = ''
    }

    this.setState({
      startDate: formattedValue
    })
  }

  onEndDateChanged(value, formattedValue) {
    if (formattedValue == null) {
      formattedValue = ''
    }

    this.setState({
      endDate: formattedValue
    })
  }

  onSourceChanged(e) {
    if (e.length > 0) {
      this.setState({
        selectedSourceId: e[0].id,
        selectedSourceName: e[0].name
      })
    } else {
      this.setState({
        selectedSourceId: 0,
        selectedSourceName: ''
      })
    }
  }

  //PROCESSING FUNCTIONS
  runPaidInvoiceBySourceReport() {
    this.setState({
      loadableState: true
    })

    if (this.validateReportForm()) {
      this.props.invoices.getPaidInvoicesBySource(this.state.selectedSourceId, this.state.startDate, this.state.endDate, () => {
        this.setState({
          loadableState: false,
        })

        //Set report to localStorage
        localStorage.setItem('crm-reports', JSON.stringify(
          [
            {
              sourceId: this.state.selectedSourceId,
              sourceName: this.state.selectedSourceName,
              startDate: this.state.startDate,
              endDate: this.state.endDate,
              defaultTab: 3,
            }
          ]
        ));

      })
    }
    else {
      alert('Please check the form.  Required data is missing.')
      this.setState({
        loadableState: false
      })
    }
  }

  removeReport() {
    localStorage.removeItem('crm-reports');
    this.props.invoices.resetPaidInvoicesBySource()
    this.setState({
      defaultTab: 1,
      selectedSourceId: 0,
      defaultSourceId: 0,
      selectedSourceName: '',
      defaultSourceName: '',
      startDate: '',
      endDate: '',
    });
  }

  formatAmount(cell, row) {
    return (
      '$' + cell.toFixed(2)
    )
  }

  formatCompanyName(cell, row) {
    let linkURL = '/company/details/' + row.quote.company.id
    return (
      <div>
        <Link to={ linkURL }>{ row.companyName }</Link>
      </div>
    )
  }

  formatActions(cell, row) {
    return (
      <div>
        <Button bsSize="small" bsStyle="warning" id={cell} onClick={() => { browserHistory.push('/invoice/' + row.quote.id) }}><i className="fa fa-pencil-square-o" aria-hidden="true"></i></Button>
      </div>
    )
  }

  render() {
    let paidInvoicesBySourceReportTable = <div>Select a source and date range above.</div>

    if (this.props.invoices.paidInvoicesBySource.length > 0) {
      paidInvoicesBySourceReportTable = (
        <div>
          <Loadable active={this.state.loadableState} spinner text='Processing your request...'>
            <BootstrapTable
              data={this.props.invoices.paidInvoicesBySource}
              striped={true}
              hover={true}
              pagination={true}
              bordered={true}
            >
              <TableHeaderColumn width="100" isKey={true} dataField="formattedPaymentDate" dataSort={true} >Date Paid</TableHeaderColumn>
              <TableHeaderColumn width="100" dataField="companyName" dataSort={true} dataFormat={this.formatCompanyName.bind(this)}>Company Name</TableHeaderColumn>
              <TableHeaderColumn width="100" dataField="amount" dataSort={true} dataFormat={this.formatAmount.bind(this)}>Amount</TableHeaderColumn>
              <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={true} autoValue={true} dataFormat={this.formatActions.bind(this)}>Actions</TableHeaderColumn>
            </BootstrapTable>
          </Loadable>
        </div>
      )
    }

    return (
      <div>
        <div>
          <PanelGroup>
            <Panel header="Report Options">
              <Form>
                <Row>
                  <FormGroup>
                    <Col sm={2} componentClass={ControlLabel}>Source:</Col>
                    <Col sm={4}>
                      <FormGroup validationState={this.getSourceValidationState()}>
                        <Typeahead clearButton labelKey="name" options={this.props.sources.data && this.props.sources.data.length > 0 ? this.props.sources.data : [{ id: 0, name: 'Loading...' }]} onChange={this.onSourceChanged.bind(this)} selected={[{ id: this.state.defaultSourceId, name: this.state.defaultSourceName }]} placeholder="Choose a source..." />
                      </FormGroup>
                    </Col>
                  </FormGroup>
                </Row>
                <Row>
                  <FormGroup>
                    <Col sm={2} componentClass={ControlLabel}>Start Date:</Col>
                    <Col sm={4}>
                      <FormGroup validationState={this.getStartDateValidationState()}>
                        <DatePicker id="startDate" dateFormat="YYYY-MM-DD" value={this.state.startDate} onChange={this.onStartDateChanged.bind(this)} />
                      </FormGroup>
                    </Col>
                    <Col sm={2} componentClass={ControlLabel}>End Date:</Col>
                    <Col sm={4}>
                      <FormGroup validationState={this.getEndDateValidationState()}>
                        <DatePicker id="endDate" dateFormat="YYYY-MM-DD" value={this.state.endDate} onChange={this.onEndDateChanged.bind(this)} />
                      </FormGroup>
                    </Col>
                  </FormGroup>
                </Row>
              </Form>
              <div style={{ float: 'right' }}>
                <Button bsStyle="danger" onClick={this.removeReport.bind(this)}><i aria-hidden="true"></i>Remove Report</Button>
                <Button bsStyle="success" onClick={this.runPaidInvoiceBySourceReport.bind(this)}><i aria-hidden="true"></i>Run Report</Button>
              </div>
            </Panel>
          </PanelGroup>
        </div>
        <div className="clearfix"></div>
        <Collapsible title="Paid Invoices By Source Report" content={paidInvoicesBySourceReportTable} />
        <div className="clearfix"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/paidinvoicesbysourcereport.js